<template>
  <div class="row">

    <!-- Content -->

    <div class="col-4 treeview">
      <tree-view ref="left"
                 class="left"
                 :data="tree"
                 :defaultValue="defaultValue"
                 :priority="priority"
                 :tips="tips"
                 :titles="titles"
                 v-on:selection="onSelectionFromLeft"/>
    </div>
    <div class="col-8 bg-white">
      <div class="card">

        <!--div :class="['card-header', color ? `card-colored bg-${color}-dark` : '',]"-->
        <div class="card-header">
          <a href="#" @click="$emit('info')" :class="`color-${color}-dark`"><fa icon="info-circle" fixed-width /></a> Informations
        </div>

        <ul class="list-group list-group-flush">

          <li v-if="id" class="list-group-item informations">
            <h5><EvaluationBadge :value="selected.value" :outline="selected.hasChildren" /> {{ $t(title) }}</h5>
            <div v-if="description" class="description" v-html="$t(description)"></div>
            <div v-else>{{ $t('evaluation.no_description') }}</div>
            <small class="text-muted">{{ $t('state') }} : {{ $t(tips + selected.value) }}</small>
          </li>

          <li v-if="id && !selected.hasChildren" class="list-group-item">
            <textarea class="form-control"
                      v-bind:class="{ 'is-invalid': selected.data.comment.length > maxLength }"
                      :placeholder="$t('evaluation.add_comment')"
                      rows="3"
                      :maxlength="maxLength"
                      v-model="selected.data.comment"
                      @change="$emit('updated')">
            </textarea>
            <small class="text-muted">
              {{ $t('evaluation.chars_left', [ maxLength - selected.data.comment.length ]) }}
            </small>
          </li>

          <li class="list-group-item">
            <div class="scrollable right">
              <tree-view ref="right"
                        :data="tree"
                        :defaultValue="defaultValue"
                        :flat="true"
                        :focus="selection"
                        :priority="priority"
                        :tips="tips"
                        :titles="titles"
                        @selection="onSelectionFromRight"
                        @updated="$emit('updated')" />
            </div>
          </li>

        </ul>

      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex'

export default {
  name: 'Evaluation',

  props: {
    evaluation: {
      type: Object,
      required: true
    },
  },

  computed: {
    color () {
      return this.evaluation.color;
    },

    data () {
      return this.evaluation.data;
    },

    defaultValue () {
      return this.evaluation.defaultValue;
    },

    description () {
      return `evaluations.${this.evaluation.title}.descriptions.${this.id}`;
    },

    maxLength () {
      return 200;
    },

    priority () {
      return this.evaluation.title == 'requirements' ? 'max' : 'min';
    },

    tips () {
      return `evaluation.tips.${this.evaluation.title}.`;
    },

    title () {
      return this.titles + this.id;
    },

    titles () {
      return `evaluations.${this.evaluation.title}.titles.`;
    }
  },

  async created () {
    this.selection = this.data[0];
    this.selected = this.selection;

    this.tree = this.$store.getters['evaluations/' + this.evaluation.title].tree;
  },

  data: () => ({
    id: 0,
    selection: null,
    selected: null,
    tree: [],
  }),

  methods: {
    getMask () {
      return this.$refs.left.getMask();
    },

    $_getSnapshot (node, list, valueToIgnore) {
      if (node.children.length == 0) {
        let sublist = [];

        if (node.value != null && (node.value != valueToIgnore || node.comment)) {
          sublist.push(node.value);
        }

        if (node.comment) {
          sublist.push(node.comment);
        }

        list.push(sublist);
      } else {
        for (let i = 0; i < node.children.length; i++) {
          this.$_getSnapshot(node.children[i], list, valueToIgnore);
        }
      }

      return list;
    },

    getSnapshot () {
      return this.$_getSnapshot(
        this.data[0],
        [],
        this.defaultValue
      );
    },

    onSelectionFromLeft (item) {
      this.setInfosFromItem(item);

      // Set current node to selected node.
      // If node is a leaf, get its parent.
      this.selection = item;
      if (!item.hasChildren) {
        this.selection = item.$parent;
      }
    },

    onSelectionFromRight (item) {
      this.setInfosFromItem(item);
    },

    /**
     * Show name and desription of node in header.
     *
     * @var Item Node to show.
     */
    setInfosFromItem (item) {
      this.id = item.data.id;
      this.selected = item;

      // If node is a leaf and hasn't a comment yet, make one.
      if (!item.hasChildren && !this.selected.data.comment) {
        Vue.set(this.selected.data, 'comment', '');
      }
    },

    update () {
      this.$refs.left.update();
      this.$refs.right.update();
    }

  },

  mounted () {
    // Initialize all popovers.
    $('[data-toggle="popover"]').popover();
  },
}
</script>

<style scoped>
  textarea {
    height: 5rem;
    resize: none;
  }

  .card-btn {
    float: right;
    position: relative;
    margin-top: -10px;
    top: 5px;
  }

  .informations {
    padding-bottom: 1.5rem;
    padding-top: 1.5rem;
  }

  .informations h5 {
    margin-bottom: 1rem;
  }

  .left {
    height: 100%;
    max-height: 800px;
    max-width: 100%;
    overflow-y: auto;
  }

  .right {
    max-height: 600px;
  }

  .treeview {
    border-right: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Evaluation.vue